export function convertKebabToCamel(kebabString: string): string {
    return kebabString.replace(/-([a-z])/g, function (g: string): string {
        return g[1].toUpperCase();
    });
}
